// eslint-disable-next-line no-unused-vars
import React from 'react';

import ProductGridItemContainer from 'Containers/Templates/ProductGridItem';

const ProductGridItem = {
  label: 'Product Grid Item',
  fields: {
    productId: { type: 'text', label: 'Product ID' },
  },
  defaultProps: {
    productId: '',
  },
  render: ({ productId }) => <ProductGridItemContainer productId={ productId } />,
};

// eslint-disable-next-line import/prefer-default-export
export { ProductGridItem };
